import Vue from 'vue'
import 'ant-design-vue/dist/antd.css'
import { Space, Icon, Steps } from 'ant-design-vue'

Vue.use(Space)
Vue.use(Icon)
Vue.use(Steps)